import React from "react";
import { Crown, Target } from "lucide-react";
import { useRecommendations } from "../context/RecommendationsContext";

function NumberCard({ icon: Icon, title, description, number, accent = "blue", small }) {
  const accents = {
    blue: "from-[#1d6cb1] to-[#2a83ce]",
    gold: "from-yellow-400 via-orange-400 to-red-500",
    emerald: "from-emerald-500 to-teal-600",
    purple: "from-fuchsia-500 to-purple-600",
  };
  const isArr = Array.isArray(number);
  const display = isArr ? number : number || "—";
  return (
    <div className="np-card bg-white rounded-2xl shadow-lg border border-blue-100 overflow-hidden">
      <div className={`bg-gradient-to-r ${accents[accent]} p-5 text-white flex items-center gap-3`}>
        <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
          <Icon className="w-5 h-5" />
        </div>
        <h3 className="font-bold text-lg">{title}</h3>
      </div>
      <div className="p-6">
        <p className="text-sm text-gray-600 mb-5 min-h-[60px]">{description}</p>
        <div className="flex items-center justify-center">
          {isArr ? (
            <div className="flex gap-3">
              {display.map((n, i) => (
                <div key={i} className="np-ball w-20 h-20 sm:w-24 sm:h-24 rounded-full flex items-center justify-center font-extrabold text-2xl sm:text-3xl shadow-md" style={{fontFamily: 'Playfair Display, serif'}}>
                  {n}
                </div>
              ))}
            </div>
          ) : (
            <div className={`np-ball ${small ? 'w-32 h-32 text-4xl' : 'w-44 h-44 text-5xl'} rounded-full flex items-center justify-center font-extrabold shadow-lg`} style={{fontFamily: 'Playfair Display, serif'}}>
              {display}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function FeaturedNumbers() {
  const { data } = useRecommendations();
  return (
    <section className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="np-title inline-block text-2xl sm:text-3xl font-extrabold text-[#0e4a7a]">
            Números Destacados del Día
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-sm sm:text-base">
            Selecciones especiales de Prometeo basadas en análisis estadístico, patrones numéricos y comportamiento reciente.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <NumberCard
            icon={Crown}
            title="Número Fuerte del Día"
            description="Destaca por su comportamiento estadístico y repetición en ciclos recientes. Ideal para jugadas directas y precisas."
            number={data?.single_strong}
            accent="blue"
          />
          <NumberCard
            icon={Target}
            title="Los 2 Números Fuertes para Hoy"
            description="Seleccionados mediante análisis de tendencias recientes y frecuencia histórica. Base estratégica para combinaciones diarias."
            number={data?.two_strong}
            accent="gold"
            small
          />
          <NumberCard
            icon={Target}
            title="Palé Recomendado del Día"
            description="Combina dos números con alta compatibilidad estadística. Una de las jugadas más populares en los sorteos."
            number={data?.recommended_pale}
            accent="emerald"
            small
          />
          <NumberCard
            icon={Crown}
            title="Tripleta del Día"
            description="Tres números seleccionados por su frecuencia, tendencia y comportamiento reciente. Ideal para mayores retornos."
            number={data?.daily_triplet}
            accent="purple"
          />
        </div>
      </div>
    </section>
  );
}
